import { UIComponentHandler, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { WishlistAPIModel, WishlistAPIModelImpl } from './wishlistapimodel';
import { WishlistViewImpl, WishlistPlaylistOptionPrivilageImpl } from './wishlistview';
import { WishlistCSSStyleImpl } from './wishlistcss';
import { GetWishlistDto } from '../../../../core/dto/wishlist/getwishlist/getwishlistdto';
import { ToneDto } from '../../../../core/dto/tonedto';
import { CRBTUIComponentProps, CRBTUIComponent } from '../crbt/crbtuicomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface WishlistComponentProps extends CRBTUIComponentProps
{
    onPlaylistClick(playlistDto: ToneDto): void;
}

export interface WishlistComponentHandler extends UIComponentHandler
{
    onPlaylistSelected(playlistDto: ToneDto): void;
    onLoadMore(title: string, startIndex: number, offset: number, searchKey: string): void;
}

export interface WishlistTabComponentHandler 
{
    onLoadMore(startIndex: number, offset: number, searchKey: string): void;
}

export class WishlistComponent extends CRBTUIComponent<WishlistComponentProps, UIComponentState> 
implements WishlistComponentHandler
{
    constructor(props: WishlistComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new WishlistViewImpl(applicationContext, uiComponentHandler);
    }

    componentDidMount()
    {
        (this.getView() as WishlistViewImpl).showLoader();
      
        (this.getAPIModel() as WishlistAPIModel).getWishlist();
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new WishlistCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new WishlistAPIModelImpl(applicationContext, apiModelHandler);
    }

    onLoadMore(title: string, startIndex: number, offset: number, searchKey: string): void 
    {
        // (this.getAPIModel() as WishlistAPIModel).loadMore(startIndex, offset, searchKey);
    }

    onPlaylistSelected(playlistDto: ToneDto): void 
    {
       let toneDto = this.props.context.getToneContext();

        if(toneDto !== null)
        {
            toneDto.setId(playlistDto.getId());
            toneDto.setTonePrivilage(new WishlistPlaylistOptionPrivilageImpl());
          
            this.props.context.setToneContext(toneDto);
    
           this.props.onPlaylistClick(playlistDto);
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as WishlistViewImpl).dismissLoader();

        if((data as GetWishlistDto).getWishlistType() === "1")
        {
            if((data as GetWishlistDto).getWishlistToneDetailsList().length === 0)
            {
                console.log("---tigerempty");
                (this.getView() as WishlistViewImpl).showPopup( this.getContext().getResources().getString(Strings.no_wishes),  AlertType.WARN,
                    this.getContext().getResources().getString(Strings.get_tunes));
            }
            else{
            (this.getView() as WishlistViewImpl).updateTonesData((data as GetWishlistDto).getWishlistToneDetailsList());
            }
        }
        
        else
        {
            // (this.getView() as WishlistViewImpl).updatePlaylistData((data as GetWishlistDto).getWishlistToneDetailsList());
        }

        window.scrollTo(0,0);
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as WishlistViewImpl).dismissLoader();
        (this.getView() as WishlistViewImpl).showPopup(description,  AlertType.ERROR,
            this.getContext().getResources().getString(Strings.ok));

            window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/wishlistcomponent.tsx